import { render, staticRenderFns } from "./CanteenSummary.vue?vue&type=template&id=7bf53fa8&scoped=true&"
import script from "./CanteenSummary.vue?vue&type=script&lang=js&"
export * from "./CanteenSummary.vue?vue&type=script&lang=js&"
import style0 from "./CanteenSummary.vue?vue&type=style&index=0&id=7bf53fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf53fa8",
  null
  
)

export default component.exports